import React from "react";
import { ThunderboltOutlined } from "@ant-design/icons";
import { Tooltip, Tag } from "antd";
const AutosledExpeditedTag = ({ bold }) => (React.createElement(Tooltip, { color: "#fff", title: "A shipment has either been sitting too long, had multiple cancellations, or a customer offers us more money to get it to them faster, so we artificially increase the price." },
    React.createElement(Tag, { color: "processing", style: { fontWeight: bold ? "bold" : "normal" } },
        React.createElement(ThunderboltOutlined, null),
        " Autosled Expedited")));
AutosledExpeditedTag.defaultProps = {
    bold: false,
};
export default AutosledExpeditedTag;
